// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__I1tiJ","contactImage":"Contact_contactImage__SQz3B","circleTitle":"Contact_circleTitle__3D3k2"};